import React from "react";
import './index.less';

import Pdf from "@/pages/pdf/business";
import {toolsMap} from "@/pages/skill/helper";
import CommonTabs from "@/pages/components/commonTabs";

export default ()=>{

    return (

        <>
            <div className="admin_container clearfix" style={{position: 'relative'}}>
                {/*<div className="menu_list ">*/}
                {/*    {*/}
                {/*        toolsMap.map((item: any) =>*/}
                {/*            <div*/}
                {/*                key={item.value}*/}
                {/*                className={1 === item.value && 'tool-menu-active' || 'tool-menu'}*/}
                {/*                onClick={() => location.href = item.path}*/}
                {/*            >{item.label}</div>*/}
                {/*        )*/}
                {/*    }*/}
                {/*</div>*/}
                <CommonTabs title='常用工具' active={1} tabs={toolsMap}/>
                <div className="admin_right">
                    <div className="has_table">
                        <Pdf/>
                    </div>
                </div>
            </div>
        </>
        // <div className="search_from  pdf_from">
        //     <div className='skill-tabs flex align-items-center'>
        //         <div className={`skill-tab ${active === 1 && 'skill-tab-active'}`} onClick={() => setActive(1)}>
        //             添加Made In China
        //             <span className='skill-tab-line'/>
        //         </div>
        //         <div className={`skill-tab ${active === 2 && 'skill-tab-active'}`} onClick={() => setActive(2)}>
        //             尾程派送费计算
        //             <span className='skill-tab-line'/>
        //         </div>
        //         <div className={`skill-tab ${active === 3 && 'skill-tab-active'}`} onClick={() => setActive(3)}>
        //             FBA仓库信息
        //             <span className='skill-tab-line'/>
        //         </div>
        //         <div className={`skill-tab ${active === 4 && 'skill-tab-active'}`} onClick={() => setActive(4)}>
        //             附加费查询
        //             <span className='skill-tab-line'/>
        //         </div>
        //     </div>
        //     {
        //         active === 1 && <Pdf/> ||
        //         active === 2 && <Fee/> ||
        //         active === 3 && <WareList/> ||  <Surcharge/>
        //     }
        // </div>
    )
}

